import React from 'react';
import bazuuDisplay from '../images/bazuugif.gif';
import mykukudisplay from '../images/mykuku.gif';
import relwoxmoneydisplay from '../images/relwoxhome.png';

const MyPortfolio = () => {
  const data = [
    {
      id: 1,
      img: bazuuDisplay,
      title: 'Bazuu Foods',
      techStack: 'HTML5, CSS3, JavaScript',
      description: 'Bazuu foods is a restaurant website that aims to showcase different foods served by the hotel.',
      live_link: 'https://nemwel-boniface.github.io/bazuu/',
      howBuiltAbbr: 'solo',
      howBuiltDesc: 'This is a project that was done as a solo',
    },
    {
      id: 2,
      img: mykukudisplay,
      title: 'My kuku',
      techStack: 'Rails, Bootstrap, CSS, PostgreSQL',
      description: 'With the software, you will be able to track a chicken from the time it is a chick all the way to when it is a fully grown chicken and become a rooster and provide meat or a hen and provide eggs and also count the number of eggs it will have laid throughout its lifetime.',
      github_link: 'https://github.com/Nemwel-Boniface/my_kuku',
      howBuiltAbbr: 'solo',
      howBuiltDesc: 'This is a project that was done as a solo',
    },
    {
      id: 3,
      img: relwoxmoneydisplay,
      title: 'Relworx Money',
      techStack: 'HTML5, CSS3, JavaScript',
      description: 'Nemwel Relworx Money is a Single Page application that aims to showcase how transactions can be handled in the client side.',
      live_link: 'https://nemwel-relworx.netlify.app/',
      github_link: 'https://github.com/Nemwel-Boniface/Relworx_Money',
      howBuiltAbbr: 'solo',
      howBuiltDesc: 'This is a project that was done as a solo',
    },
  ];

  const listProjects = data.map(
    (element) => (
      <div key={element.id} className="project">
        <img src={element.img} alt={`${element.title} project preview`} />
        <div className="projectBody">
          <div className="projectHeader">
            <h2>{element.title}</h2>
            <p><abbr title={element.howBuiltDesc}>{element.howBuiltAbbr}</abbr></p>
          </div>
          <p>
            {element.description}
            {' '}
          </p>

          <ul className="techstacks">
            {element.techStack.split(',').map((tech) => (
              <li key={tech}>{tech}</li>
            ))}
          </ul>
          {element.github_link
            ? (
              <div className="buttonGrp">
                <button type="button"><a href={element.live_link} target="_blank" rel="noreferrer">See project</a></button>
                <button type="button"><a href={element.github_link} target="_blank" rel="noreferrer">See Github</a></button>
              </div>
            ) : (
              <button type="button"><a href={element.live_link} target="_blank" rel="noreferrer">See project</a></button>
            )}
        </div>
      </div>
    ),
  );
  return (
    <div className="MyPortfolio" id="portfolio">
      <div className="sectionHeading">
        <div className="sectionLeftHeading">
          <h3 className="headingPinked">My works</h3>
          <h2>What I have done</h2>
        </div>
        <div className="sectionRightMoreDetails">
          <a href="https://github.com/Nemwel-Boniface" target="_blank" rel="noreferrer">More projects</a>
        </div>
      </div>

      <div className="recentworks">
        {listProjects}
      </div>
    </div>
  );
};

export default MyPortfolio;
